<template>
  <div class="mb-content">
    <div class="safe-top" :style="'padding-top: ' + safeTop + 'px;'">
      <Banner/>

      <!-- tab切换（仅移动端） -->
      <Tab
        :list="tabList"
        :currentIndex="tabIndex"
        @changeNavType="changeNavType"
      ></Tab>

      <!-- 视频列表 -->
      <div class="list_box">
        <div class="no_length" v-if="!navList || navList.length === 0">
          {{ $t('category.noData') }}
        </div>
        <VideoList
          v-else
          :list="navList"
          @item-click="goDetailVideo"
        ></VideoList>
      </div>

      <tabBar currentNav="category" />
    </div>
  </div>
</template>

<script>
import tabBar from "@/components/tabBar.vue";
import Banner from "@/components/module/banner.vue"
import Tab from "@/components/module/tab.vue"
import VideoList from "@/components/module/videoList.vue";

import {videoList} from "@/apis/video"
export default {
  name: "CategoryPage",
  components: {
    tabBar,
    Banner,
    Tab,
    VideoList,
  },
  data() {
    return {
      userinfo: null,
      openidInfo: null,
      screenWidth: window.innerWidth,
      safeTop: 0, // 状态栏高度，Web 中可设为 0 或通过其他方式获取
      isObtain: true,
      tabList: [],
      navList: [],
      tabIndex: 0,
      qdjl: 0,
      tdsy: 0,
      navLock: false,
      datasa: [],
      showdyxx: true,
      dataconfig: [],
      banners: [],
      datainfo: [],
      dataindex: [],
      newsa: [],
      record: [],
      sign_list: [],
      query: {
        limit: 10,
        offset: 1,
      },
      typeid: null,
    };
  },
  mounted() {
    // 获取状态栏高度（模拟安全区）
    // Web 中可使用 CSS constant(safe-area-inset-top) 处理，此处简单设为 0
    this.safeTop = 0;
    // 读取用户信息
    const userInfoStr = localStorage.getItem("userinfo");
    if (userInfoStr) {
      this.userinfo = JSON.parse(userInfoStr);
    }
    const openidStr = localStorage.getItem("openidInfo");
    if (openidStr) {
      this.openidInfo = JSON.parse(openidStr);
    }
    // 设置页面标题
    document.title = this.$t('category.title');
    // 获取数据
    this.getTabList();
    // 监听滚动到底部
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 获取视频分类和列表
    getTabList(typeid) {
      typeid = typeid || "";
      if (this.typeid == null) {
        this.typeid = typeid;
      }
      const currentTypeId = typeid;

      videoList({
            offset: this.query.offset,
            limit: this.query.limit,
            lx: 1,
            typeid: currentTypeId,
        })
        .then((res) => {
          if (currentTypeId !== this.typeid) return;
          const result = res.typedata.type.slice(1);
          const langType = "117";          
          this.tabList = result.map(item => {
            return {
              ...item,
              name:item.name[langType],
            }
          })
          
          if (this.isObtain) {
            this.typeid = this.tabList[0].id;
            this.isObtain = false;
            this.getTabList(this.tabList[0].id);
          } else {
            if (this.query.offset === 1) {
              this.navList = res.rows || [];
            } else {
              this.navList = this.navList.concat(res.rows || []);
            }
          }
        })
        .catch((err) => {
          console.error("获取分类列表失败", err);
        });
    },
    changeNavType(index) {
      const newTypeId = this.tabList[index].id;
      if (newTypeId === this.typeid) return;
      this.tabIndex = index;
      this.navList = [];
      this.query.offset = 1;
      this.typeid = newTypeId;
      this.getTabList(newTypeId);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    goDetailVideo(data) {
      let fxpid = 1;
      if (this.userinfo && this.userinfo.id) {
        fxpid = this.userinfo.id;
      }
      this.$router.push({
        path: "/video/details/details",
        query: { vid: data.id, mid: 0, fxpid: fxpid },
      });
    },
    // 滚动加载更多
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollTop + windowHeight >= documentHeight - 100) {
        if (this.navList.length > 0 && this.typeid !== null) {
          this.query.offset += 1;
          this.getTabList(this.typeid);
        }
      }
    }
  },
};
</script>

<style scoped>
/* 基础样式 */
.mb-content {
  width: 100%;
  max-width: 450px;
  min-height: 100vh;
  margin: 0 auto;
  transition: background 0.3s;
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
}

.light {
  background: #f5f5f7;
  color: #1d1d1f;
}

.dark {
  background-color: #181818;
  color: #f3f3f3;
}

/* .safe-top { */
  /* 安全区顶部内边距由动态样式控制 */
/* } */

.list_box {
  padding: 0 10px 86px; /* 20upx -> 10px */
}

.no_length {
  text-align: center;
  padding: 64px 16px;
  color: #8e8e93;
  font-size: 13px;
  font-weight: 500;
}

/* 以下为原样式中的其他辅助类（保留可能用到的） */
.mb-content :deep(.banner-container) {
  position: sticky;
  top: 0;
  z-index: 20;
}

.mb-content :deep(.header-banner) {
  height: 49px;
  padding: 0 16px;
  background: rgba(245, 245, 247, 0.9);
  color: #1d1d1f;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: none;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
}

.mb-content :deep(.header-center) {
  color: #1d1d1f;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  text-shadow: none;
}

.mb-content :deep(.header-right) {
  gap: 12px;
  color: #007aff;
  font-size: 18px;
}

.mb-content :deep(.header-right .icon) {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 32px;
  padding: 0;
  color: #007aff;
}

.clear-height {
  display: block;
  height: calc(50px + constant(safe-area-inset-bottom));
  height: calc(50px + env(safe-area-inset-bottom));
}
.home__footer[tag2] {
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: #bfbfbf;
  font-size: 12px;
  background: #000;
}
.home__footer-icon[tag2] {
  width: 118.5px;
  height: 27.5px;
}
</style>
